import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useSpareItem, SpareItem } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<SpareItem>
    useData={useSpareItem}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
